/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useEffect } from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { DisconnectBuildertrendAccount } from '../../../../hooks/purchase-history-hooks';
import { builderTrendHostName } from '../../../../utils/buildertrend-utils';
import { getWindow } from '../../../../utils/general';
import { IBtApiState } from '../../../../models/purchase-history';

import '../../../../styles/buildertrend.scss';

interface IBuildertrendModalFooter {
  handleClose: () => void;
  userIsLinked: boolean;
  btApiState: IBtApiState;
  setBtApiState: (value: IBtApiState) => void;
  adminUnlinkRadio: 'customer' | 'user';
}

// Connect Click
const handleConnectClick = () => {
  const getHostName = getWindow()?.location.hostname || '';
  const encodedRedirectURI = encodeURIComponent(
    `https://${getHostName}/myaccount/purchase-history`,
  );

  getWindow()?.location.assign(
    `https://${builderTrendHostName()}?oauthRedirectType=thd&redirect_uri=${encodedRedirectURI}&state=STATE`,
  );
};

const renderConnectDisconnectButton = (
  btApiState: IBtApiState,
  setBtApiState: (value: IBtApiState) => void,
  userIsLinked: boolean,
  btnTextLogic: string,
  adminUnlinkRadio: 'customer' | 'user',
) => {
  if (!btApiState?.btResponse) {
    return (
      <button
        className="sui-bg-[#004FD6] sui-text-[#cccccc] hover:sui-text-inverse sui-font-semibold sui-py-2 sui-px-4 sui-border sui-border-strongest hover:sui-border-transparent sui-rounded sui-w-40 disabled:sui-cursor-wait "
        type="button"
        disabled={btApiState.isLoading}
        onClick={() => {
          if (userIsLinked) {
            DisconnectBuildertrendAccount(
              adminUnlinkRadio,
              btApiState,
              setBtApiState,
            );
          } else {
            handleConnectClick();
          }
        }}
      >
        {btApiState.isLoading ? (
          <svg
            className="sui-animate-spin sui-inline-flex"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            data-testid="LoadingIcon"
          >
            <path
              d="M0 12a12 12 0 1024 0 12 12 0 10-24 0M4 12a8 8 0 1016 0 8 8 0 10-16 0"
              className="sui-opacity-25"
              fill="currentColor"
              fillRule="evenodd"
            />
            <path
              className="sui-opacity-75"
              fill="currentColor"
              d="M 4 12 a 8 8 0 0 1 8 -8 V 0 C 5.373 0 0 5.373 0 12 h 4 z m 2 5.291 A 7.962 7.962 0 0 1 4 12 H 0 c 0 3.042 1.135 5.824 3 7.938 l 3 -2.647"
            />
          </svg>
        ) : (
          btnTextLogic
        )}
      </button>
    );
  }
  return undefined;
};

/**
 * Buildertrend Footer element and components
 */
export const BuildertrendModalFooter = ({
  handleClose,
  userIsLinked,
  btApiState,
  setBtApiState,
  adminUnlinkRadio,
}: IBuildertrendModalFooter) => {
  const btnTextLogic = userIsLinked ? 'Disconnect' : 'Connect';

  useEffect(() => {
    return () => {
      setBtApiState({ ...btApiState, btResponse: undefined });
    };
  }, []);

  /**
   * Button style for close btn, currently uses Ghost variant until told otherwise.
   *  */
  return (
    <div className="sui-flex sui-justify-end sui-w-full sui-pt-6">
      <div className="sui-w-28">
        <Button
          variant="ghost"
          onClick={() => {
            handleClose();
          }}
        >
          Close
        </Button>
      </div>
      {renderConnectDisconnectButton(
        btApiState,
        setBtApiState,
        userIsLinked,
        btnTextLogic,
        adminUnlinkRadio,
      )}
    </div>
  );
};
